export default __webpack_public_path__ + "static/media/High_five 1.220ddae8.svg";